var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("table", { staticClass: "results-table" }, [
    _c("thead", [
      _c(
        "tr",
        _vm._l(_vm.header, function (col, i) {
          return _c(
            "TableHeader",
            {
              key: col.key,
              attrs: { col: col, disabled: _vm.disabled, sort: _vm.sort },
              on: {
                changeSort: function ($event) {
                  return _vm.$emit("changeSort", $event)
                },
              },
            },
            [
              i === 0 && col.field === "group"
                ? _c(
                    "v-popover",
                    {
                      staticStyle: { display: "inline-block" },
                      attrs: { offset: "5" },
                    },
                    [
                      _c(
                        "a",
                        { attrs: { role: "button", title: "Column meanings" } },
                        [
                          _c("span", {
                            staticClass: "fa fa-lg fa-question-circle",
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c("template", { slot: "popover" }, [
                        _c(
                          "table",
                          {
                            staticClass: "table table-condensed",
                            staticStyle: {
                              "table-layout": "auto",
                              "max-width": "calc(100vw - 75px)",
                              width: "500px",
                            },
                          },
                          [
                            _c(
                              "tbody",
                              _vm._l(_vm.definitions, function (row, i) {
                                return _c(
                                  "tr",
                                  { key: i },
                                  _vm._l(row, function (cell, j) {
                                    return _c("td", { key: j }, [
                                      _vm._v(_vm._s(cell)),
                                    ])
                                  }),
                                  0
                                )
                              }),
                              0
                            ),
                          ]
                        ),
                      ]),
                    ],
                    2
                  )
                : _vm._e(),
            ],
            1
          )
        }),
        1
      ),
    ]),
    _vm._v(" "),
    _c(
      "tbody",
      { class: { "has-foreign-hit": _vm.hasForeignHit(_vm.rows) } },
      [
        _vm._l(_vm.rows.rows, function (row, index) {
          return [
            row.type === "doc" && !_vm.showTitles
              ? void 0
              : [
                  _c(
                    row.type === "doc"
                      ? "DocRow"
                      : row.type === "hit"
                      ? "HitRow"
                      : "GroupRow",
                    _vm._g(
                      {
                        tag: "component",
                        class: {
                          rounded: true,
                          open: _vm.openRows[row.hit_id || index],
                          interactable: _vm.isOpenable(row),
                          topborder:
                            index > 0 &&
                            "first_of_hit" in row &&
                            row.first_of_hit,
                          bottomborder:
                            "last_of_hit" in row &&
                            row.last_of_hit &&
                            index < _vm.rows.rows.length - 1,
                          muted: row.muted,
                        },
                        attrs: {
                          row: row,
                          info: _vm.info,
                          cols: _vm.cols,
                          maxima: _vm.rows.maxima,
                          open: !!_vm.openRows[row.hit_id || index],
                          disabled: _vm.disabled,
                          type: _vm.type,
                          query: _vm.query,
                          hoverMatchInfos:
                            row.hit_id === _vm.hoverMatchInfosId
                              ? _vm.hoverMatchInfos
                              : undefined,
                        },
                        on: {
                          hover: function ($event) {
                            _vm.hoverMatchInfos = $event
                            _vm.hoverMatchInfosId = row.hit_id
                          },
                          unhover: function ($event) {
                            _vm.hoverMatchInfos = undefined
                          },
                        },
                        nativeOn: {
                          click: function ($event) {
                            return _vm.toggleRow(index)
                          },
                        },
                      },
                      _vm.$listeners
                    )
                  ),
                  _vm._v(" "),
                  !_vm.disableDetails
                    ? _c(
                        row.type === "doc"
                          ? "DocRowDetails"
                          : row.type === "hit"
                          ? "HitRowDetails"
                          : "GroupRowDetails",
                        _vm._g(
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.openRows[row.hit_id || index],
                                expression: "openRows[row.hit_id || index]",
                              },
                            ],
                            tag: "component",
                            class: {
                              details: true,
                              rounded: true,
                              open: _vm.openRows[row.hit_id || index],
                              muted: row.muted,
                            },
                            attrs: {
                              row: row,
                              info: _vm.info,
                              cols: _vm.cols,
                              maxima: _vm.rows.maxima,
                              open: !!_vm.openRows[row.hit_id || index],
                              disabled: _vm.disabled,
                              type: _vm.type,
                              query: _vm.query,
                              hoverMatchInfos:
                                row.hit_id === _vm.hoverMatchInfosId
                                  ? _vm.hoverMatchInfos
                                  : undefined,
                            },
                            on: {
                              hover: function ($event) {
                                _vm.hoverMatchInfos = $event
                                _vm.hoverMatchInfosId = row.hit_id
                              },
                              unhover: function ($event) {
                                _vm.hoverMatchInfos = undefined
                              },
                              close: function ($event) {
                                return _vm.toggleRow(index)
                              },
                              openFullConcordances: function ($event) {
                                return _vm.openFullConcordances(row)
                              },
                            },
                          },
                          _vm.$listeners
                        )
                      )
                    : _vm._e(),
                ],
          ]
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }